// Get Serial Timeline Use Case

import {InventoryRepository} from '../repository/InventoryRepository';
import {SerialTimelineResponse} from '../models/inventory.model';

export class GetSerialTimelineUseCase {
  constructor (private inventoryRepository: InventoryRepository) {}

  async execute (serialNumber: string, page = 1, limit = 50): Promise<SerialTimelineResponse> {
    return this.inventoryRepository.getSerialTimeline(serialNumber, page, limit);
  }
}
